import { QRCodeSVG } from 'qrcode.react'

import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { m } from '@/lib/paraglide/messages'

export interface GrowerQRDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    /** Tên hộ, hiện dưới tiêu đề để người quét biết QR của ai. */
    growerName?: string | null
    phone?: string | null
    /** Đang tải hồ sơ hộ — khác hẳn "hộ không có SĐT", đừng gộp hai trạng thái. */
    loading?: boolean
    /**
     * Tải hồ sơ hộ thất bại. Bắt buộc là trạng thái riêng: gộp vào nhánh "chưa
     * có số điện thoại" là nói với hộ rằng hồ sơ của họ thiếu dữ liệu, trong
     * khi thực ra chỉ là hỏng mạng.
     */
    error?: boolean
    onRetry?: () => void
}

/**
 * QR chứa **số điện thoại thô** của một hộ trồng (vd `0912345678`), để máy nào
 * quét cũng ra đúng con số — không bọc `tel:` hay URL.
 */
export function GrowerQRDialog({
    open,
    onOpenChange,
    growerName,
    phone,
    loading = false,
    error = false,
    onRetry,
}: GrowerQRDialogProps) {
    const value = phone?.trim() ?? ''

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-xs">
                <DialogHeader>
                    <DialogTitle>{m.grower_qr_title()}</DialogTitle>
                    <DialogDescription>{growerName ?? ''}</DialogDescription>
                </DialogHeader>

                {loading ? (
                    <p className="py-6 text-center text-sm text-muted-foreground">
                        {m.grower_qr_loading()}
                    </p>
                ) : error ? (
                    <div className="flex flex-col items-center gap-3 py-4">
                        <p className="text-center text-sm text-muted-foreground">
                            {m.my_grower_load_error()}
                        </p>
                        {onRetry && (
                            <Button type="button" onClick={onRetry}>
                                {m.my_grower_retry()}
                            </Button>
                        )}
                    </div>
                ) : value ? (
                    <div className="flex flex-col items-center gap-3 py-2">
                        {/* Nền trắng cố định: QR trên nền tối là quét không ra. */}
                        <div className="rounded-xl bg-white p-3">
                            <QRCodeSVG value={value} size={200} />
                        </div>
                        <p className="text-lg font-semibold tracking-wide">
                            {value}
                        </p>
                    </div>
                ) : (
                    <p className="py-6 text-center text-sm text-muted-foreground">
                        {m.grower_qr_no_phone()}
                    </p>
                )}
            </DialogContent>
        </Dialog>
    )
}
